export const styles = {
  wrap: {
    height: '100%',
    display: 'grid',
    gridAutoRows: 'max-content',
  },
};
